@use '../../../common/styles/variables' as *;

:host {
  display: block;
  @include default-css-variables;
  width: inherit;
}

.nylas-notetaker-config {
  width: inherit;
  display: flex;
  flex-direction: column;
  margin: 1rem;
  border-radius: var(--nylas-border-radius-2x);
  border: 1px solid var(--nylas-base-200);

  .header {
    padding: 1rem;
    border-bottom: 1px solid var(--nylas-base-200);

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      color: var(--nylas-base-900);
      text-align: left;
    }

    p {
      margin: 0.5rem 0 0 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: var(--nylas-base-600);
      text-align: left;
    }
  }

  .content {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    background-color: var(--nylas-base-25);
  }

  .primary-toggle {
    padding: 1rem;
    background-color: var(--nylas-base-50);
    border: 1px solid var(--nylas-base-200);
    border-radius: var(--nylas-border-radius);
    margin-bottom: 0.5rem;
  }

  .section {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    .section-title {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: var(--nylas-base-900);
      text-align: left;
    }

    .section-description {
      margin: 0;
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
      color: var(--nylas-base-600);
      text-align: left;
    }

    .section-content {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-left: 0.5rem;
    }
  }

  // Styling for slotted label content in checkbox components
  .label {
    margin-left: 32px;
    font-size: 14px;
    font-weight: 400;
    color: var(--nylas-base-800);
    line-height: 20px;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .label-contents {
      margin: 0;
      display: inline-block;
      color: var(--nylas-base-900);
    }

    tooltip-component {
      display: inline-block;
    }
  }

  // Enhanced disabled/readonly checkbox styling
  .checkbox-container.checkbox-disabled,
  .primary-toggle.checkbox-disabled {
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;

    // Style the label content when checkbox is disabled
    .label {
      color: var(--nylas-base-500) !important;
      cursor: not-allowed;

      .label-contents {
        color: var(--nylas-base-500) !important;
      }
    }

    // Style the checkbox component itself
    checkbox-component {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  // Ensure smooth transitions
  .checkbox-container,
  .primary-toggle {
    transition: opacity 0.2s ease;
  }

  .label {
    transition: color 0.2s ease;
  }

  .input-container,
  .textarea-container {
    margin-left: 0;
    position: relative;

    .input-help-text {
      margin: 0.5rem 0 0 0;
      color: var(--nylas-base-600);
      font-size: 13px;
      line-height: 18px;
    }

    .field-error-message {
      margin-top: 0.5rem;
      color: var(--nylas-color-red-700);
      font-size: 14px;
      line-height: 20px;
    }

    .character-count {
      margin-top: 0.25rem;
      color: var(--nylas-base-600);
      font-size: 12px;
      line-height: 16px;
      text-align: right;
    }
  }

  .error-message {
    padding: 0.75rem;
    background-color: var(--nylas-color-red-50);
    border: 1px solid var(--nylas-color-red-300);
    border-radius: var(--nylas-border-radius);
    color: var(--nylas-color-red-700);
    font-size: 14px;
    line-height: 20px;
  }

  .info-message {
    padding: 0.75rem;
    background-color: var(--nylas-color-blue-50);
    border: 1px solid var(--nylas-color-blue-300);
    border-radius: var(--nylas-border-radius);
    color: var(--nylas-color-blue-700);
    font-size: 14px;
    line-height: 20px;
  }
}
